import "./PopUp.scss";
import modelOne from "../../images/avatar1.jpg";
import modelTwo from "../../images/avatar2.jpg";
import modelThree from "../../images/avatar3.jpg";
import modelFour from "../../images/avatar4.jpg";
import modeFive from "../../images/avatar5.jpg";
import modelSix from "../../images/avatar6.jpg";
import modelSeven from "../../images/avatar7.jpg";
import { simplyClick } from "../../helpers";
import ButtonSubmit from "../ButtonSubmit";

function PopUp({ closePopUp, step }) {
  simplyClick("sh_lnd_photos_bnr", { text: `step${step}` });

  return (
    <div className="pop__up-blur">
      <div className="pop__up-block">
        <span
          onClick={() => {
            closePopUp();
            simplyClick("cl_lnd_photos_bnr_cross", { text: `step${step}` });
          }}
          className="close"
        />
        <div className="model__block">
          <img src={modelOne} alt="model" />
          <img src={modelTwo} alt="model1" />
          <img src={modelThree} alt="model2" />
          <img src={modelFour} alt="model3" />
          <img src={modeFive} alt="model4" />
          <img src={modelSix} alt="model5" />
          <img src={modelSeven} alt="model6" />
        </div>
        <h2 className="pop__title">Curious and eager for connection? Let’s make it happen!</h2>
        <p className="pop__subtitle">
          Become a member to unlock profiles and start chatting
        </p>

        <ButtonSubmit
          onClick={() => {
            closePopUp();
            simplyClick("cl_lnd_photos_bnr_btn", { text: `step${step}` });
          }}
          className="button__global button__promo model_popup_button"
          text={"Join now"}
        />
      </div>
    </div>
  );
}
export default PopUp;
